import Event from "../core/interfaces/Event";
import OContentModel from "../models/OContentModel";

export default class VideoThumbnailController {
  private thumbnailCache: { [eventId: string]: HTMLImageElement } = {};

  public async setUpVideoThumbnails(
    events: Array<Event>,
    eventListSelector: string = "#EventList"
  ): Promise<void> {
    const processedEvents = new Set<number>();
    const eventList = document.querySelector(eventListSelector);

    for (const event of events.filter(
      (e) => new Date(e.dateEnd) < new Date()
    )) {
      const eventContainer = eventList?.shadowRoot.querySelector(
        `#event-${event.eventID}`
      );

      if (!eventContainer || processedEvents.has(event.eventID)) continue;
      processedEvents.add(event.eventID);

      if (this.thumbnailCache[event.eventID]) {
        if (!eventContainer.querySelector(".event-thumbnail")) {
          eventContainer.appendChild(
            this.thumbnailCache[event.eventID].cloneNode(true)
          );
        }
        continue;
      }

      const videoString = await OContentModel.getEventVideoReplay(
        event.eventID.toString()
      );
      const entryIdKaltura = videoString?.match(
        /entry_id=([a-zA-Z0-9_-]+)/
      )?.[1];
      const entryIdYoutube = videoString?.match(
        /(?:youtube\.com\/(?:embed\/|watch\?v=|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
      )?.[1];

      const thumbnailUrl = entryIdKaltura
        ? `https://cfvod.kaltura.com/p/2171811/sp/217181100/thumbnail/entry_id/${entryIdKaltura}/height/500/width/622`
        : entryIdYoutube
        ? `https://img.youtube.com/vi/${entryIdYoutube}/maxresdefault.jpg`
        : `https://www.oracle.com/webfolder/community/ccc/prod/images/custom-pages/video-coming-soon.png`;

      if (!eventContainer.querySelector(".event-thumbnail")) {
        const imgElement = Object.assign(document.createElement("img"), {
          src: thumbnailUrl,
          alt: `Thumbnail for ${event.eventID}`,
          className: "event-thumbnail",
          style: "border-radius: 6px; align-self: center;",
        });
        eventContainer.appendChild(imgElement);
        this.thumbnailCache[event.eventID] = imgElement.cloneNode(
          true
        ) as HTMLImageElement;
      }
    }
  }

  public clearCache(): void {
    this.thumbnailCache = {};
  }
}
